export default __webpack_public_path__ + "static/media/07__o_5.c9b07be2.jpg";